import './ProstayCloudbeds.css'
import { useTranslation } from 'react-i18next';

function ProstayCompetition() {
    const { t } = useTranslation();


    return (
        <div className='d-flex flex-column flex-xl-row justify-content-center prostay-competition page-content align-items-center'>
            <div className='col-12 col-xl-6'>
                <h2>{t('Why Prostay Stands Out from the Competition!')}</h2>
                <p className='mt-4'>
                    {t('Prostay eliminates repetitive tasks—auto‑sending payment reminders, handling smart room assignments, updating reservation status, and generating reports—saving about 10 hours per staff member per week.')}
                </p>
                <p className='mt-4'>
                    {t('With fewer manual steps and fewer errors, your team spends more time on guests, boosting speed, accuracy, and staff satisfaction.')}
                </p>
                <div className='d-flex white-box-competition'>
                    <div className='d-flex flex-column' style={{ borderRight: '1px solid #D6D6D6', paddingRight:'10px' }}>
                        <h4>70%</h4>
                        <h6>{t('hotel automation')}</h6>
                    </div>
                    <div className='d-flex flex-column' style={{ borderRight: '1px solid #D6D6D6', paddingRight:'10px' }}>
                        <h4>{'>10h'}</h4>
                        <h6>{t('saved every week')}</h6>
                    </div>
                    <div className='d-flex flex-column'>
                        <h4>100%</h4>
                        <h6>{t('staff satisfaction')}</h6>
                    </div>
                </div>
            </div>
            <div className='col img-wrapper'>
                <img className='center-content-img-width' style={{maxWidth:'100%'}} src='/images/prostay-vs-competition.svg' alt={"Prostay vs competition"} />
            </div>
        </div>
    )
}

export default ProstayCompetition;